import { InjectionToken } from "@angular/core";
/** The API key can be found in avo.app, logged in as mlab */
export const AvoApiKey = "bfw5Ar5sJv07ebGgCGKH";

export interface AvoConfigurationParameters {
  avoInspectorApiKey: string;
  appVersion: string;
  appName: string;
}

export class AvoConfiguration {
  appName: string;
  appVersion: string;
  avoInspectorApiKey: string;

  constructor(parameters: AvoConfigurationParameters) {
    this.avoInspectorApiKey = parameters.avoInspectorApiKey;
    this.appVersion = parameters.appVersion;
    this.appName = parameters.appName;
  }
}

export const AVO_CONFIGURATION = new InjectionToken<AvoConfiguration>(
  "AvoConfiguration"
);
